import Request from '../utils/request'

export function getPersonalPlanList (params) {
  return Request({
    url: '/follow/personalPlan/list',
    method: 'get',
    params
  })
}

export function getPersonalPlanByIdOrPatientIdApi (id, patientId) {
  return Request({
    url: `follow/personalPlan/detail?id=${id}&${patientId ? 'patientId=' + patientId : ''}`,
    method: 'get'
  })
}

export function getPersonalPlanOrderByPatientIdApi (patientId) {
  return Request({
    url: `/follow/planPackageWorkOrder/page?patientId=${patientId}&page=1&size=100`,
    method: 'get'
  })
}

export function getSolutionScheduleByIdApi (id) {
  return Request({
    url: `/follow/treatSolution/scheduleDetail?id=${id}`,
    method: 'get'
  })
}

export function getPersonalPlanOrderCutPageScrollApi (params) {
  return Request({
    url: '/cutPage/api/cutPageScroll',
    method: 'get',
    params
  })
}

export function getPersonalPlanOrderCutPageSelectorApi (params) {
  return Request({
    url: '/cutPage/api/cutPageSelector',
    method: 'get',
    params
  })
}

// 家庭医生服务
export function getProductSupplierPageApi (params) {
  return Request({
    url: '/follow/productSupplier/page',
    method: 'get',
    params
  })
}

// 家庭医生服务报告
export function getFamilyDoctorWorkOrderPageApi (params) {
  return Request({
    url: '/follow/familyDoctorWorkOrder/page',
    method: 'get',
    params
  })
}

// 在线会诊报告
export function getOnlineConsultationWorkOrderPageApi (params) {
  return Request({
    url: '/follow/onlineConsultationWorkOrder/page',
    method: 'get',
    params
  })
}

// consulting/page?patientId=1
export function getConsultingPageApi (params) {
  return Request({
    url: '/follow/consulting/page',
    method: 'get',
    params
  })
}

// supplier/page?supplierType=2&id=1 医生主页
export function getSupplierPageApi (params) {
  return Request({
    url: '/follow/supplier/page',
    method: 'get',
    params
  })
}

// supplier/nameList?supplierType=2
export function getSupplierNameListApi (params) {
  return Request({
    url: '/follow/supplier/nameList',
    method: 'get',
    params
  })
}
